<template>
    <section class="contact" id="contact">
        <h2 class="contact__title">{{ title }}</h2>
        <div class="wrap contact__wrap">
            <div class="contact__block">
                <div class="contact__info">
                    <ul class="contact__list">
                        <li class="contact__item row" v-for="(c,i) in contacts" :key="i">
                            <div class="contact__item-wrap contact__icon icon">
                                <img class="icon__img" :src="require('@/assets/contacts/'+ c.icon +'.svg')" alt="">
                                <div class="icon__badge"></div>
                            </div>
                            <div class="contact__item-wrap contact__item-info">
                                <a :href="c?.link || '#'" class="contact__item-title">{{ c.title[lang] }}</a>
                                <!--<p class="contact__item-information">{{ c.more_info }}</p>-->
                                <!--<p class="contact__item-information">{{ c.contact }}</p>-->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ContactUs",
    props:{
        data: Object,
    },
    data() {
        return {
            defaultValue: {
                "title": {
                    "en": "Contact Us",
                    "es": "Contact Us",
                    "pt": "Contact Us"
                },
                "contacts": [
                    {
                        "title": {
                            "en": "12973 SW 112 Street Suite 239 Miami, FL 33186",
                            "es": "12973 SW 112 Street Suite 239 Miami, FL 33186",
                            "pt": "12973 SW 112 Street Suite 239 Miami, FL 33186"
                        },
                        "description": {
                            "en": "",
                            "es": "",
                            "pt": ""
                        },
                        "link": "#",
                        "icon": "map-point"
                    },
                    {
                        "title": {
                            "en": "212-660-4994",
                            "es": "212-660-4994",
                            "pt": "212-660-4994"
                        },
                        "description": {
                            "en": "",
                            "es": "",
                            "pt": ""
                        },
                        "link": "tel:212-660-4994",
                        "icon": "phone-2"
                    },
                    {
                        "title": {
                            "en": "pmsales@prometheuspro.us",
                            "es": "pmsales@prometheuspro.us",
                            "pt": "pmsales@prometheuspro.us"
                        },
                        "description": {
                            "en": "",
                            "es": "",
                            "pt": ""
                        },
                        "link": "#",
                        "icon": "mail"
                    }
                ]
            }
        }
    },
    computed:{
        lang() {
            return this.$i18n.locale
        },
        content() {
            return this.data || this.defaultValue
        },
        title(){
            return  this.content?.title[this.lang]
        },
        contacts(){
            return this.content?.contacts
        }
    }
}
</script>

<style scoped>

</style>